import Button from '@mui/material/Button';
import { IJourneyResp, ISchedules } from '../../../../services/journey.service';
import Schedule from './Schedule';
import { Root, SectionTitle } from './styled';
import RescheduleReason from '../../../shared/Calendar/RescheduleReason';
import ViewMoreWrapper from '../../../shared/ViewMoreWrapper';
import SchedulesViewModel from './viewModel';

interface Props {
  journey: IJourneyResp;
}

const Schedules = ({ journey }: Props) => {
  const {
    isPlaceholder,
    activeSchedules,
    pastSchedules,
    hasMore,
    showMore,
    openCalendarReschedule,
    isOpen,
    handleConfirm,
    handleCancel
  } = SchedulesViewModel(journey);

  if (isPlaceholder) return null;

  return (
    <Root>
      {activeSchedules.length > 0 && (
        <>
          <SectionTitle variant="subtitle1">Agendamentos atuais</SectionTitle>
          {activeSchedules.map((schedule: ISchedules) => (
            <Schedule key={schedule.id} schedule={schedule} openCalendar={openCalendarReschedule} />
          ))}
        </>
      )}

      {pastSchedules.length > 0 && (
        <>
          <SectionTitle variant="subtitle1">Agendamentos realizados</SectionTitle>
          {pastSchedules.map((schedule: ISchedules) => (
            <Schedule key={schedule.id} schedule={schedule} openCalendar={openCalendarReschedule} />
          ))}
          {hasMore && (
            <ViewMoreWrapper>
              <Button variant="inline" color="primary" onClick={showMore}>
                ver mais
              </Button>
            </ViewMoreWrapper>
          )}
        </>
      )}

      <RescheduleReason open={isOpen} onConfirm={handleConfirm} onCancel={handleCancel} />
    </Root>
  );
};

export default Schedules;
